export default __webpack_public_path__ + "static/media/room.5f05c9a4.xlsm";